import { getGameCanvasStandards, shrinkTextFontByArea } from '../../helpers/gameCanvasHelper';
import { convertAmount, parseNumberByPrecision, userInfoStore } from '@pascal/pascal-core';
import { doBetsStore } from '../../store';
import { rowBetBlockImages, roundStates } from '../../enums';
import { getRoundLifeCycle } from './index';

const betBlockHovering = (data) => {
  const { ctx } = getGameCanvasStandards();
  const { x, y, w, h } = data;
  ctx.strokeStyle = '#FF008C';
  ctx.lineWidth = 1;
  ctx.strokeRect(x, y, w, h);
};

export const betBlock = (betBlock, configs) => {
  const { ctx } = getGameCanvasStandards();
  const { betAmount } = doBetsStore;
  let { x, y, w, h, odd, amount } = betBlock;
   w-=2; h-=2; y+=1; x+=1;

  const grd = ctx.createLinearGradient(0, y + configs.grd.y1, 0, y + configs.grd.y2);
  grd.addColorStop(0, configs.grd.color1);
  grd.addColorStop(1, configs.grd.color2);
  ctx.lineWidth = 1;

  ctx.fillStyle = configs.strokeColor;
  ctx.fillRect(x, y, w, h);

  ctx.fillStyle = grd;
  ctx.strokeStyle = configs.strokeColor;
  ctx.beginPath();
  ctx.roundRect(x, y, w, h, 6);
  ctx.fill();
  ctx.strokeRect(x, y, w, h);

  configs.icons.forEach((icon) => {
    ctx.drawImage(icon.img, x + icon.xDiff, y + icon.yDiff, icon.w, icon.h);
  });

  ctx.font = `900 ${configs.odd.fontSize}px ZektonRg-Regular`;
  ctx.fillStyle = configs.odd.color;
  ctx.fillText('x' + odd, x + configs.odd.xDiff, y + configs.odd.yDiff);

  const betBlockAmount = amount ? amount : betAmount;
  const possibleWinAmount = parseNumberByPrecision(betBlockAmount, odd);
  const amountText = `${convertAmount(possibleWinAmount)}${userInfoStore.currencySymbolOrCode}`;

  const textMaxSpaceWith = betBlock.w-configs.amount.xDiff;
  shrinkTextFontByArea(amountText, textMaxSpaceWith, configs.amount.fontSize, 'ZektonRg-Regular', 900);

  ctx.fillStyle = configs.amount.color;
  ctx.fillText(amountText, x + configs.amount.xDiff, y + configs.amount.yDiff);

  configs.texts.forEach((text) => {
    ctx.font = `900 ${text.fontSize}px ZektonRg-Regular`;
    ctx.fillStyle = text.color;
    ctx.fillText(text.content, x + text.xDiff, y + text.yDiff);
  });
};

const drawBetBlock = (betBlockData) => {
  const blockConfigs = betBlockData.getDrawingConfigs();
  betBlock(betBlockData, blockConfigs);
};

const drawRowBetBlocks = () => {
  const { ctx } = getGameCanvasStandards();
  const { rowBetBlocks, mouseOnCanvas, isBetBlocksClickable } = doBetsStore;

  rowBetBlocks.forEach((rowBetBlock) => {
    const { x, y, isRowClicked, isInRange, rowBlockIndexes } = rowBetBlock;
    const betBlocksInRow = rowBlockIndexes.length;

    const isBlockHighlighting = isRowClicked() || (isBetBlocksClickable && isInRange(mouseOnCanvas.x, mouseOnCanvas.y));

    isBlockHighlighting
      ? ctx.drawImage(rowBetBlockImages.highlighting[betBlocksInRow], x + 18, y + 13, 44, 23)
      : ctx.drawImage(rowBetBlockImages.default[betBlocksInRow], x + 20, y + 13, 40, 22);
  });
};

const drawVeilBlock = (block, opacity=0.2) => {
  const { x, y, w, h } = block;
  const { ctx } = getGameCanvasStandards();
  ctx.fillStyle = `rgb(0,0,0,${opacity})`;
  ctx.fillRect(x, y, w, h);
};

export const drawBetBlocks = () => {
  const { betBlocks, isShowBetBlocks, hoveredBlock } = doBetsStore;
  if (!isShowBetBlocks) {
    return;
  }

  betBlocks.forEach((betBlockData) => {
    drawBetBlock(betBlockData);
    betBlockData.isDisable && drawVeilBlock(betBlockData, 0.4);
    getRoundLifeCycle() === roundStates.betClosed && drawVeilBlock(betBlockData);
  });

  hoveredBlock && !hoveredBlock.isDisable && hoveredBlock.x < 900 && betBlockHovering(hoveredBlock);

  drawRowBetBlocks();
};
